import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, map, filter, isEqual } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Typeahead } from 'modules/typeahead';
import { DATA_TYPES } from 'constants/common';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { multiSelectField as MultiSelectField } from 'ui/views/generic/multiSelectField';
 *
 * // render
 * <MultiSelectField propName='propValue'/>
 */
export const multiSelectField = ( props ) => {

    // get error message (ref)
    const errorMessage = get( props.error, 'message', null );
    const hasError = ! isEmpty( errorMessage );

    // dynamic class name
    const widgetClassName = classnames( 'ui-multi-select-field', props.className, {
        'ui-multi-select-field--error': hasError,
    } );
    
   return (
       <div className={ widgetClassName }>
           <div className='ui-multi-select-field'>
               
               {/* label */}
               <div className='ui-multi-select-field__label'>

                   {/* label text */}
                   <div className='ui-multi-select-field__label__text'>{ getLabel( props.label ) }</div>

                   {/* required asterisk */}
                   {
                       props.required ? (
                           <div className='ui-multi-select-field__label__asterisk'>*</div>
                       ) : null
                   }
               </div>

               {/* select */}
               <div className='ui-multi-select-field__select'>
                   <Typeahead
                        placeholder={ get( props, 'placeholder', 'Select' ) }
                        size={ get( props, 'size', 'medium' ) }
                        url={ props.url }
                        type={ DATA_TYPES.MULTI_SELECT }
                        ignoreQueryChangeOnSelect={ true }
                        selected = { props.value  }
                        searchable= { true }
                        hideIcon = { props.hideIcon }
                        onChange={ ( { selected } ) => props.onChange( {
                            name: props.name,
                            value: selected,
                        } ) }
                   />
               </div>
               <div className='ui-multi-select-field__content'>
                        {! isEmpty( props.value ) &&
                            <SelectedItems data={ props.value } onChange={ props.onChange } name={ props.name }/>
                        }
               </div>
           </div>

           {/* error message */}
           {
               hasError ? (
                   <div className='ui-multi-select-field__error'>
                       <div className='ui-multi-select-field__error__message'>
                           { getLabel( errorMessage ) }
                       </div>
                   </div>
               ) : null
           }
       </div>
   );
};

// section 2
const SelectedItems = ( { data = [], onChange, name='' } ) => {

    const handleChange= ( props ) => {

        const update= filter( data, item => !isEqual( props, item ) );
        onChange( {
            name: name,
            value: update
        } );
    };

    return (
        <div className='ui-multi-select-field__selected'>
            <div className='ui-multi-select-field__selected__box'>
            {
                map( ( data ), item => {

                    return (
                        <div key={ item } className='ui-multi-select-field__selected__item'>
                            <div className='ui-multi-select-field__selected__item__name'>
                                { item }
                            </div>
                            <div className='ui-multi-select-field__selected__item__icon' onClick={ () => handleChange( item ) }>
                            <Icon name='cross' width={ 10 }  height={ 10 }  />
                            </div>
                        </div>
                    );
                } )
                }
            </div>
        </div>
    );
};


// set display name
multiSelectField.displayName = 'multiSelectField';

// set default props
multiSelectField.defaultProps = {};

// prop types
multiSelectField.propTypes = {};
